<template>
  <div>
    <el-card
      style="min-height: 200px; padding: 20px"
      v-loading="loading"
      shadow="never"
    >
      <div v-if="editModel && !errorMsg">
        <template v-if="demandItemList && demandItemList.length > 0">
          <el-form
            ref="form"
            :size="$xUISize"
            :model="editModel"
            :rules="editRules"
            @submit.native.prevent
            label-width="auto"
            label-position="top"
          >
            <el-form-item label="补货方式" prop="replenishType">
              <el-radio-group v-model="editModel.replenishType">
                <el-radio label="replenish_purchase">仓库统采</el-radio>
                <el-radio label="replenish_transfer">仓库调货</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="供货清单" prop="itemList">
              <div style="padding: 0px">
                <el-table
                  stripe
                  :data="demandItemList"
                  :cell-class-name="delLine"
                  :size="$xUISize"
                >
                  <el-table-column label="商品信息" min-width="380px">
                    <template slot-scope="scope">
                      <div style="margin-right: 10px">
                        <goods-sku-info :skuInfo="scope.row.skuInfo">
                          <template slot="info-append" slot-scope="sco">
                            <div style="color: #919191; font-size: 14px">
                              <span> 需求数量: </span>
                              <template>
                                <span
                                  style="color: #333333; font-weight: bolder"
                                >
                                  {{ scope.row.plannedGoodsCount }}
                                </span>
                                <span> 份商品 </span>
                              </template>
                            </div>
                          </template>
                        </goods-sku-info>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="成本单价" width="180px">
                    <template slot-scope="scope">
                      <template v-if="getItemBySkuGuid(scope.row.skuGuid)">
                        <el-input
                          type="number"
                          v-model="
                            getItemBySkuGuid(scope.row.skuGuid).costPrice
                          "
                          :disabled="
                            editModel.replenishType != 'replenish_purchase'
                          "
                          @change="handleItemGoodsChange(scope.row)"
                          placeholder="成本单价"
                          style="width: 140px"
                        >
                        </el-input>
                      </template>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="供货单价" width="180px">
                    <template slot-scope="scope">
                      <template v-if="getItemBySkuGuid(scope.row.skuGuid)">
                        <el-input
                          type="number"
                          v-model="
                            getItemBySkuGuid(scope.row.skuGuid).purchasePrice
                          "
                          @change="handleItemGoodsChange(scope.row)"
                          placeholder="供货单价"
                          style="width: 140px"
                        >
                        </el-input>
                      </template>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="供货数量" width="200px">
                    <template slot-scope="scope">
                      <template v-if="getItemBySkuGuid(scope.row.skuGuid)">
                        <el-input-number
                          v-model="
                            getItemBySkuGuid(scope.row.skuGuid).purchaseCount
                          "
                          @change="
                            handleItemGoodsChange(
                              getItemBySkuGuid(scope.row.skuGuid)
                            )
                          "
                          placeholder="供货数量"
                          style="width: 140px"
                          :min="1"
                        ></el-input-number>
                      </template>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120px">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="danger"
                        v-if="!!getItemBySkuGuid(scope.row.skuGuid)"
                        @click="removeItemClick(scope.row)"
                      >
                        取消
                      </el-button>
                      <el-button
                        v-else
                        size="mini"
                        type="primary"
                        @click="addItemClick(scope.row)"
                      >
                        添加
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="color: #999999; font-size: 14px; margin-top: 20px">
                  * 请添加并完善报价清单信息
                </div>
              </div>
            </el-form-item>
            <el-form-item label="采购信息" prop="purchaseOrderRemark">
              <el-input
                type="textarea"
                v-model="editModel.purchaseOrderRemark"
                :rows="2"
                maxlength="256"
                placeholder="输入采购订单信息"
                show-word-limit
              ></el-input>
              <div style="color: #999999; font-size: 14px">
                * 输入采购平台、订单号码、快递单号等信息
              </div>
            </el-form-item>
            <el-form-item label="运费成本" prop="freightCost" key="freightCost">
              <el-input
                type="number"
                @change="handleItemChange"
                v-model="editModel.freightCost"
                placeholder="请输入运费成本"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="运费金额"
              prop="freightAmount"
              key="freightAmount"
            >
              <el-input
                type="number"
                @change="handleItemChange"
                v-model="editModel.freightAmount"
                placeholder="请输入运费金额"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="优惠金额"
              prop="discountAmount"
              key="discountAmount"
            >
              <el-input
                type="number"
                @change="handleItemChange"
                v-model="editModel.discountAmount"
                placeholder="请输入优惠金额"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注说明" prop="optRemark">
              <el-input
                type="textarea"
                v-model="editModel.optRemark"
                :rows="3"
                maxlength="256"
                placeholder="输入备注说明内容"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item>
              <div style="color: #999999; font-size: 14px; margin-bottom: 10px">
                合计金额:
                <span style="font-size: 18px; color: #f56c6c">
                  {{ editModel.totalAmount || 0 }}元
                </span>
              </div>
              <el-button
                type="primary"
                :loading="editSubmit"
                :disabled="
                  editSubmit ||
                  !editModel.itemList ||
                  editModel.itemList.length <= 0
                "
                @click="submitClick"
              >
                提交
              </el-button>
            </el-form-item>
          </el-form>
        </template>
        <div v-else style="color: #ff0000; font-size: 14px">
          当前要货单已全部报价
        </div>
      </div>
      <el-empty
        v-else-if="!loading && errorMsg"
        :description="errorMsg"
        :image-size="100"
      >
        <el-button v-if="errorMsg" @click="fetchModel" size="small">
          重新加载
        </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<script>
import goodsSkuInfo from '../../../../components/business/goodsSkuInfo.vue';
import goodsSkuSelect from '../../../../components/business/goodsSkuSelect.vue';

const defaultModel = {
  replenishType: "replenish_purchase",
  itemList: [],
  freightCost: 0,
  freightAmount: 0,
  discountAmount: 0,
  totalAmount: 0,
  costAmount: 0,
}

export default {
  components: {
    goodsSkuInfo,
    goodsSkuSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      demandItemList: [],
      editSubmit: false,
      editModel: null,
      editRules: {
        storeGuid: [
          {
            required: true,
            message: "请选择门店或仓库",
            trigger: "change",
          },
        ],
        replenishType: [
          {
            required: true,
            message: "补货方式不能为空",
            trigger: "change",
          },
        ],
        itemList: [
          {
            validator: (rule, value, callback) => {
              callback();
            },
            required: true,
            trigger: "change",
          }
        ],
      },
    };
  },
  methods: {
    delLine({ row, column, rowIndex, columnIndex }) {
      if (!this.getItemBySkuGuid(row.skuGuid)) return "del_line";
    },
    validate() {
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },
    getItemBySkuGuid(skuGuid) {
      let findItem;
      (this.editModel.itemList || []).forEach(item => {
        if (item.skuGuid == skuGuid) {
          findItem = item;
        }
      });
      return findItem;
    },
    addItemClick(item) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let flag = false;
      this.editModel.itemList.forEach((i) => {
        if (i.skuGuid == item.skuGuid) {
          flag = true;
        }
      });
      if (!flag) {
        this.editModel.itemList.unshift(Object.assign({}, item));
      }
      this.handleItemChange();
    },
    removeItemClick(row) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let indexOf = -1;
      this.editModel.itemList.forEach((i, index) => {
        if (row.skuGuid == i.skuGuid) {
          indexOf = index;
        }
      })
      if (indexOf >= 0) {
        this.editModel.itemList.splice(indexOf, 1);
      }
      this.handleItemChange();
    },
    handleItemGoodsChange(item) {
      if (item.purchaseCount < 0) {
        item.purchaseCount = 0;
      }
      if (item.purchasePrice < 0) {
        item.purchasePrice = 0;
      }
      if (item.costPrice < 0) {
        item.costPrice = 0;
      }
      item.totalAmount = Number(
        Number(item.purchasePrice * item.purchaseCount).toFixed(2)
      );
      item.costAmount = Number(
        Number(item.costPrice * item.purchaseCount).toFixed(2)
      );
      this.handleItemChange();
    },
    handleItemChange() {
      this.editModel.costAmount = Number(this.editModel.costAmount) || 0;
      this.editModel.totalAmount = (Number(this.editModel.freightAmount) || 0)
        - (Number(this.editModel.discountAmount) || 0);
      (this.editModel.itemList || []).forEach((item) => {
        if (item.purchaseCount < 0) {
          item.purchaseCount = 0;
        }
        if (item.purchasePrice < 0) {
          item.purchasePrice = 0;
        }
        if (item.costPrice < 0) {
          item.costPrice = 0;
        }
        item.totalAmount = Number(
          Number(item.purchasePrice
            * item.purchaseCount).toFixed(2)
        );
        item.costAmount = Number(
          Number(item.costPrice
            * item.purchaseCount).toFixed(2)
        );
        this.editModel.totalAmount
          += Number(item.totalAmount);
        this.editModel.costAmount
          += Number(item.costAmount);
        this.editModel.totalAmount = Number(
          Number(this.editModel.totalAmount).toFixed(2)
        );
        this.editModel.costAmount = Number(
          Number(this.editModel.costAmount).toFixed(2)
        );
      });
    },
    checkItemList() {
      let flag = true;
      this.editModel.itemList.forEach((i) => {
        if (i.purchaseCount < 0) {
          flag = false;
        }
      });
      if (!flag) {
        this.error("清单列表数量不能小于0");
      }
      return flag;
    },
    submitClick() {
      if (!this.checkItemList()) {
        return;
      }
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          this.requestApi("biz.warehouse.replenish.info.create",
            this.editModel, { showError: true }).then((resp) => {
              this.success("提交成功");
              this.$drawer.refreshDrawer();
              this.$drawer.backDrawer();
            }).finally(() => {
              this.editSubmit = false;
            });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      this.handleItemChange();
    },
    fetchModel() {
      // 编辑
      this.loading = true;
      this.errorMsg = null;
      this.editModel = null;
      return this.requestApi("biz.warehouse.demand.info.detail", {
        guid: this.pageParams.demandGuid,
        storehouseGuid: this.pageParams.storehouseGuid,
      }).then((resp) => {
        return this.requestApi('biz.warehouse.demand.item.list', {
          demandGuid: resp.data.guid,
          storehouseGuid: resp.data.storehouseGuid,
          optReplenish: "0",
          optPurchase: "0",
        }).then((listResp) => {
          this.demandItemList = (listResp.data.list || []).map((item) => {
            return {
              skuGuid: item.skuGuid,
              skuInfo: item.skuInfo,
              plannedGoodsCount: item.plannedGoodsCount,
              purchaseCount: item.plannedGoodsCount,
              purchasePrice: "",
              costPrice: "",
              totalAmount: 0,
              costAmount: 0
            };
          })
          this.editModel = Object.assign({}, defaultModel, {
            storeGuid: resp.data.storehouseGuid,
            demandGuid: resp.data.guid,
            demandStoreGuid: resp.data.storeGuid,
            itemList: []
          })
          this.handleModel();
        })
      }).catch((err) => {
        this.errorMsg = (err && err.msg) || (err && err.message)
          || "数据加载失败";
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  created() {
    this.fetchModel();
  },
};
</script>